exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fb-banner[data-v-2df833fc]{width:100%;display:block;background-color:#221f20\n}\n.fb-banner img[data-v-2df833fc]{width:100%;height:auto\n}\n@media(max-width: 769px){\n.fb-banner[data-v-2df833fc]{display:none\n}\n}\n.fb-banner.fb-banner-mobile[data-v-2df833fc]{display:none\n}\n@media(max-width: 769px){\n.fb-banner.fb-banner-mobile[data-v-2df833fc]{display:block\n}\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2df833fc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/facebook-group/FacebookGroup.vue
// module id = zJdO
// module chunks = 1